<template lang="pug">
  div.rewards-page-container

    div.rewards-page-main-img
      img(src="@/assets/rewards-main-img.svg")

    div.rewards-page-text-part
      span.h3 Выберите установленное у вас приложение

    a.rewards-page-choose-app(:href="deepLink")
      img(src="@/assets/circle-logo-kiddie-coin.svg")
      span.h4.text-part-choose-app Kiddie Coin

</template>

<script>
export default {
  name: 'KiddLinks',

  data() {
    return {
      type: "",
      params: ""
    }
  },

  computed: {
    deepLink() {
      return `kiddieapp://kiddiecoin.ru/deeplinkrewards/${this.type}/${this.params}`;
    }
  },

  beforeDestroy() {
    document.body.style.background="white"
  },

  beforeMount() {
    document.body.style.background="#F7F8FC"

    this.type = this.$route.params.type
    this.params = this.$route.params.rest
  },
}
</script>

<style scoped>
.rewards-page-container {
  padding: 0 16px;
}
.rewards-page-main-img {
  display: flex;
  justify-content: center;
  margin: 45px auto 55px auto;
}
.rewards-page-text-part {
  display: flex;
  justify-content: center;
  text-align: center;
  width: 220px;
  margin: 0 auto 23px auto;
}
.rewards-page-choose-app {
  display: flex;
  height: 68px;
  border-radius: 15px;
  background: #FFFFFF;
  padding: 13px 0 17px 13px;
  margin-bottom: 16px;
  text-decoration: none;     
  color: inherit;            
}
.text-part-choose-app {
  margin: 9px 0 9px 8px;
}
</style>